module.exports = __webpack_public_path__ + "assets/images/project/menu/germany-thumb.jpg?v=784f0ef0";